import { ComponentType } from 'react';
import * as ComponentsList from './ComponentsList';
import { ComponentProps } from '../marketplace/template/src/components/global/ComponentsLibrary';

// eslint-disable-next-line import/prefer-default-export
export function loadSyncComponent<K extends keyof typeof ComponentsList>(
  componentName: K,
) {
  if (componentName in ComponentsList) {
    return ComponentsList[componentName] as ComponentType<
    ComponentProps[K]
    >;
  }

  throw new Error(`Component ${componentName} not found`);
}
